import { type JSX } from 'react/jsx-runtime';

export const AUTOMATE_WORK_DARK = (): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 275 275" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="55" y="55" width="165" height="165" rx="24" fill="#D4A800" />
		<path
			d="M150 70 L110 145 H140 L125 205 L175 120 H145 L150 70Z"
			fill="#E2E3E4"
			stroke="#E2E3E4"
			strokeWidth="4"
			strokeLinejoin="round"
		/>
	</svg>
);
